import { Form, Modal } from "antd";
import React from "react";
import { CreateAirSzzPointDto } from "../../../api";
import { airSzzPointsColumns } from "../form/columns";

interface AirSzzPointFormProps {
  visible: boolean;
  setVisible: Function;
  onCreateAirSzzPoint: (values: CreateAirSzzPointDto) => void;
}

export const AirSzzPointForm: React.FC<AirSzzPointFormProps> = ({ visible, setVisible, onCreateAirSzzPoint }) => {
  const [form] = Form.useForm<CreateAirSzzPointDto>();

  return (
    <Modal open={visible} onOk={form.submit} okText="Создать" cancelText="Отмена" onCancel={() => setVisible(false)}>
      <Form form={form} className="p-8" layout="vertical" onFinish={onCreateAirSzzPoint}>
        {airSzzPointsColumns.map(({ title, dataIndex, rules, inputNode }, index) => (
          <Form.Item label={title} name={dataIndex} rules={rules} key={index}>
          {inputNode}
          </Form.Item>
        ))}
      </Form>
    </Modal>
  );
};
